// extracted by mini-css-extract-plugin
export default {"textAmmount":"Dashboard_textAmmount__ar1QX","textAmmountSub":"Dashboard_textAmmountSub__vIC-L","CardAmmount":"Dashboard_CardAmmount__X6uO7"};